import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/JWTContext';
import StyledEngineProvider from '@material-ui/core/StyledEngineProvider';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
        <StyledEngineProvider injectFirst>
            <BrowserRouter>
              <AuthProvider>
                <App />
              </AuthProvider>    
            </BrowserRouter>
        </StyledEngineProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
